import { render, staticRenderFns } from "./CommandVar.vue?vue&type=template&id=b7990028&scoped=true&"
import script from "./CommandVar.vue?vue&type=script&lang=ts&"
export * from "./CommandVar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7990028",
  null
  
)

export default component.exports